import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16d89310"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex position-absolute w-100 h-100 align-items-center justify-content-center",
  style: {"background-color":"rgba(255, 255, 255, 0.5)","z-index":"1060"}
}
const _hoisted_2 = { class: "d-block text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1))
const _hoisted_4 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title fw-bold" }, "Completar teléfono")
], -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, " Para mejorar tu experiencia en el club y poder acercarte nuevos beneficios, registrá tu número de teléfono. ", -1))
const _hoisted_9 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_10 = {
  key: 1,
  class: "alert alert-danger mt-3"
}
const _hoisted_11 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormPhone = _resolveComponent("FormPhone")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal fade", { show: _ctx.show }]),
      style: _normalizeStyle({ display: _ctx.show ? 'block' : 'none' }),
      tabindex: "-1",
      role: "dialog",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false"
    }, [
      (_ctx.loading.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("h6", null, _toDisplayString(_ctx.loading.text), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
              default: _withCtx(() => [
                _createVNode(_component_FormPhone, {
                  modelValue: _ctx.telefono,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.telefono) = $event)),
                  required: true,
                  label: "formularios.telefono.label",
                  placeholder: ""
                }, null, 8, ["modelValue"]),
                (_ctx.telefonoError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.telefonoError), 1))
                  : _createCommentVNode("", true),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary px-4 py-2",
                    disabled: !_ctx.telefono || _ctx.telefonoError !== null
                  }, " Guardar ", 8, _hoisted_12)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ])
      ])
    ], 6),
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["modal-backdrop fade", { show: _ctx.show }])
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}